import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["FirewallRequest"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getFirewallRequest: build.query<
        GetFirewallRequestApiResponse,
        GetFirewallRequestApiArg
      >({
        query: () => ({ url: `/FirewallRequest` }),
        providesTags: ["FirewallRequest"],
      }),
      getFirewallRequestBySubstation: build.query<
        GetFirewallRequestBySubstationApiResponse,
        GetFirewallRequestBySubstationApiArg
      >({
        query: (queryArg) => ({ url: `/FirewallRequest/${queryArg}` }),
        providesTags: ["FirewallRequest"],
      }),
      putFirewallRequestById: build.mutation<
        PutFirewallRequestByIdApiResponse,
        PutFirewallRequestByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/FirewallRequest/${queryArg.id}`,
          method: "PUT",
          body: queryArg.firewallRequestDeviceDto,
        }),
        invalidatesTags: ["FirewallRequest"],
      }),
      getFirewallRequestBySubstationGenerateNi: build.mutation<
        GetFirewallRequestBySubstationGenerateNiApiResponse,
        GetFirewallRequestBySubstationGenerateNiApiArg
      >({
        query: (queryArg) => ({
          url: `/FirewallRequest/${queryArg}/generateNI`,
          method: "GET",
        }),
        invalidatesTags: ["FirewallRequest"],
      }),
      getFirewallRequestBySubstationGenerateSi: build.mutation<
        GetFirewallRequestBySubstationGenerateSiApiResponse,
        GetFirewallRequestBySubstationGenerateSiApiArg
      >({
        query: (queryArg) => ({
          url: `/FirewallRequest/${queryArg}/generateSI`,
          method: "GET",
        }),
        invalidatesTags: ["FirewallRequest"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as firewallRequestApi };
export type GetFirewallRequestApiResponse =
  /** status 200 OK */ FirewallRequestDeviceDto[];
export type GetFirewallRequestApiArg = void;
export type GetFirewallRequestBySubstationApiResponse =
  /** status 200 OK */ FirewallRequestDeviceDto[];
export type GetFirewallRequestBySubstationApiArg = string;
export type PutFirewallRequestByIdApiResponse = /** status 200 OK */ void;
export type PutFirewallRequestByIdApiArg = {
  id: number;
  firewallRequestDeviceDto: FirewallRequestDeviceDto;
};
export type GetFirewallRequestBySubstationGenerateNiApiResponse =
  /** status 200 OK */ void;
export type GetFirewallRequestBySubstationGenerateNiApiArg = string;
export type GetFirewallRequestBySubstationGenerateSiApiResponse =
  /** status 200 OK */ void;
export type GetFirewallRequestBySubstationGenerateSiApiArg = string;
export type FirewallRequestDeviceDto = {
  deviceId?: number;
  measurementPoint?: string | null;
  macAddress?: string | null;
  ipAddress?: string | null;
  subnetMask?: string | null;
  substation?: string | null;
  switchgear?: string | null;
  hostName?: string | null;
  defaultGateway?: string | null;
  connectionPort?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetFirewallRequestQuery,
  useLazyGetFirewallRequestQuery,
  useGetFirewallRequestBySubstationQuery,
  useLazyGetFirewallRequestBySubstationQuery,
  usePutFirewallRequestByIdMutation,
  useGetFirewallRequestBySubstationGenerateNiMutation,
  useGetFirewallRequestBySubstationGenerateSiMutation,
} = injectedRtkApi;
